/*
 * WW Image Grid — mobile tap preview (products cards)
 * Version: 1.1.0 - 2026-08-07 10:05 (UTC+8) - Plaud Tayler — gate widened to touch OR <=767 width (narrow mouse windows report hover:hover and the tap did nothing)
 * Version-note: 1.0.0 - 2026-08-07 09:40 (UTC+8) - Plaud Tayler — first version: on touch devices a card
 *   tap toggles .is-tap-hover (same visual state as desktop hover: image swap + text colors);
 *   one card open at a time; navigation is CTA-only (the full-card hotspot is hidden on mobile).
 * Document-delegated, binds once, survives Section Rendering API hot-reload.
 */
(function () {
  if (window.__wwImageGridTap) return;
  window.__wwImageGridTap = true;

  /* touch devices OR mobile widths: a narrow desktop window (no touch emulation) reports
     hover:hover, but the full-card hotspot is already hidden at <=767 — clicks must still
     toggle the preview there - Plaud Tayler - 2026-08-07 10:05 */
  var touchMq = window.matchMedia('(hover: none), (max-width: 767.98px)');

  document.addEventListener('click', function (e) {
    if (!touchMq.matches) return;
    var item = e.target.closest && e.target.closest('.image-grid--slider .image-grid__item');
    if (!item) return;
    if (e.target.closest('.image-grid__btn')) return; /* CTA keeps navigating */
    var on = !item.classList.contains('is-tap-hover');
    var host = item.closest('.image-grid--slider');
    Array.prototype.forEach.call(host.querySelectorAll('.image-grid__item.is-tap-hover'), function (el) {
      el.classList.remove('is-tap-hover');
    });
    if (on) item.classList.add('is-tap-hover');
  });
})();
